<app-breadcrumbs title="{{ id ? 'CUSTOMER_ORDERS.EDIT_TITLE' : 'CUSTOMER_ORDERS.CREATE_TITLE' }}" [first]="'MENU.ADMINISTRATION.CUSTOMER_ORDERS'" [url]="'/customer-orders'" [id]="breadcrumbsId"></app-breadcrumbs>

<div class="btn-container">
    <report-single-btn *ngIf="company && formData"  [reportCode]="'ORDER'" [documentForPrint]="formData"></report-single-btn>
    <dx-button *ngIf="((authorities.create && id == null) || (authorities.update && id != null))" [disabled]="!pendingChanges" class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="save" [disabled]="!pendingChanges" [text]="'SHARED.SAVE_CHANGES' | translate" type="success" (onClick)="saveChanges($event)"></dx-button>
</div>
<div class="row">
    <div class="col-12 col-xl-6">
        <div class="row">
            <div class="col-7">
                <div [ngClass]="{ 'form-vertical': formData?.upcPayments || formData?.opaPayments}" class="fs-12 payment">
                    <ng-container *ngIf="formData?.upcPayments">
                        <p class="fs-13 text-bolder text-center">{{ 'UPC_PAYMENTS.HEADING' | translate  }}</p>
                        <ng-container *ngFor="let upc of formData.upcPayments; let last = last;">
                            <ng-container *ngIf="last">
                                <div class="mx-2">
                                    <span class="dx-field-item-label-text"> {{ 'UPC_PAYMENTS.APPROVAL_CODE' | translate  }}:</span>
                                    <span class="pull-right text-bolder">{{ upc.ApprovalCode }}</span>
                                </div>
                                <div class="mx-2">
                                    <span class="dx-field-item-label-text">{{ 'SHARED.EMAIL'  | translate }}: </span>
                                    <span class="pull-right text-bolder">{{ upc.Email }}</span>
                                </div>
                                <div class="mx-2">
                                    <span class="dx-field-item-label-text">{{ 'UPC_PAYMENTS.ORDER_ID' | translate  }}: </span>
                                    <span class="pull-right text-bolder">{{ upc.OrderID }}</span>
                                </div>
                                <div class="mx-2">
                                    <span class="dx-field-item-label-text">{{ 'UPC_PAYMENTS.PROXYPAN' | translate  }}: </span>
                                    <span class="pull-right text-bolder">{{ upc.ProxyPan }} </span>
                                </div>
                                <div class="mx-2">
                                    <span class="dx-field-item-label-text">{{ 'SHARED.DESCRIPTION' | translate  }}: </span>
                                    <span class="pull-right text-bolder">{{ upc.PurchaseDesc }}</span>
                                </div>
                                <div *ngIf="formData?.payed" class="mx-2">
                                    <span class="dx-field-item-label-text">{{ 'UPC_PAYMENTS.AMOUNT' | translate  }}: </span>
                                    <span class="pull-right text-bolder">{{ utilityService.thousandSeparator(upc.TotalAmount / 100) }}</span>
                                </div>
                                <div class="mx-2">
                                    <span class="dx-field-item-label-text">XID : </span>
                                    <span class="pull-right text-bolder">{{ upc.XID }}</span>
                                </div>
                            </ng-container>
                        </ng-container>
                        <div class="text-center">
                            <div class="fs-20 text-bold mr-2 pt-1 mt-3">
                                <span *ngIf="formData?.payed">
                                    <i class="ti-check"></i>
                                    {{ 'SHARED.PAID' | translate }}
                                </span>
                                <span *ngIf="!formData?.payed">
                                    <i class="ti-close"></i>
                                    {{ 'SHARED.UNPAID' | translate }}
                                </span>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="formData?.opaPayments">
                        <p class="fs-13 text-bolder text-center">{{ 'UPC_PAYMENTS.HEADING' | translate  }}</p>
                        <ng-container *ngFor="let opa of formData.opaPayments; let last = last;">
                            <ng-container *ngIf="last">
                                <div class="mx-2">
                                    <span class="dx-field-item-label-text">OPA ID:</span>
                                    <span class="pull-right text-bolder">{{ opa.opaId }}</span>
                                </div>
                                <div class="mx-2">
                                    <span class="dx-field-item-label-text">{{ 'OPA_PAYMENTS.ACCOUNT_NUMBER'  | translate }}: </span>
                                    <span class="pull-right text-bolder">{{ opa.accountNumber }}</span>
                                </div>
                                <div class="mx-2">
                                    <span class="dx-field-item-label-text">{{ 'SHARED.DESCRIPTION' | translate  }}: </span>
                                    <span class="pull-right text-bolder">{{ opa.message }}</span>
                                </div>
                                <div *ngIf="formData?.payed" class="mx-2">
                                    <span class="dx-field-item-label-text">{{ 'UPC_PAYMENTS.AMOUNT' | translate  }}: </span>
                                    <span class="pull-right text-bolder">{{ opa.amount }} </span>
                                </div>
                                <div class="mx-2">
                                    <span class="dx-field-item-label-text">{{ 'SHARED.DATE_CREATED' | translate  }}: </span>
                                    <span class="pull-right text-bolder">{{ utilityService.formatDateTimeView(opa.dateTime) }}</span>
                                </div>
                                <div class="mx-2">
                                    <span class="dx-field-item-label-text">{{ 'OPA_PAYMENTS.PAYMENT_ORDER_ID' | translate  }}: </span>
                                    <span class="pull-right text-bolder">{{ opa.paymentOrderId }}</span>
                                </div>
                                <div *ngIf="opa.refunded" class="mx-2">
                                    <span class="dx-field-item-label-text">{{ 'OPA_PAYMENTS.REFUNDED' | translate  }}: </span>
                                    <span class="pull-right text-bolder">{{ opa.refunded }}</span>
                                </div>
                            </ng-container>
                        </ng-container>
                        <div class="text-center">
                            <div class="fs-20 text-bold mr-2 pt-1 mt-3">
                                <span *ngIf="formData?.payed">
                                    <i class="ti-check"></i>
                                    {{ 'SHARED.PAID' | translate }}
                                </span>
                                <span *ngIf="!formData?.payed">
                                    <i class="ti-close"></i>
                                    {{ 'SHARED.UNPAID' | translate }}
                                </span>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="col-5">
                <div *ngIf="orderStatus" class="text-right">
                    <div>
                        <span class="fs-20 text-bold mr-1 pt-1">
                            <mat-icon [matTooltip]="'ENUMS.BANNER_SCOPES.USER_TYPE' | translate" matTooltipPosition='above' class="fs-14 opacity8 clickable">info</mat-icon>
                        </span>
                        <dx-text-box class="bg-secondary-theme p-1 width-200 pull-right" [(value)]="userType" [readOnly]="true"></dx-text-box>
                    </div>
                    <br />
                    <div>
                        <span class="fs-20 text-bold mr-1 pt-1">
                            <mat-icon (click)="log()" [matTooltip]="'SHARED.STATUS' | translate" matTooltipPosition='above' class="fs-14 opacity8 clickable">info</mat-icon>
                        </span>
                        <dx-select-box #orderStatusSelect [readOnly]="!allowStatusChange" class="bg-secondary-theme p-1 width-200 pull-right select-box {{orderStatus}}" [items]="statuses"
                            [showClearButton]="false" [(value)]="orderStatus" displayExpr="label" valueExpr="value"
                            (onValueChanged)="pendingChanges = true">
                        </dx-select-box>
                    </div>
                </div>
                <!-- <div *ngIf="formData?.paymentMethod?.type == 'ON_LINE'" class="text-right">
                    <div class="fs-20 text-bold mr-2 pt-1 mt-3">
                        <span *ngIf="formData?.payed">
                            <i class="ti-check"></i>
                            {{ 'SHARED.PAID' | translate }}
                        </span>
                        <span *ngIf="!formData?.payed">
                            <i class="ti-close"></i>
                            {{ 'SHARED.UNPAID' | translate }}
                        </span>
                    </div>
                </div> -->
            </div>
        </div>
        <dx-form #form class="form-vertical mt-3 field-item-no-pb" [formData]="formData" [showColonAfterLabel]="false" (onFieldDataChanged)="fieldDataChanged($event)">
            <dxi-item itemType="group">
                <dxo-col-count-by-screen [lg]="2" [md]="2" [xs]="1" [sm]="2"></dxo-col-count-by-screen>
                <dxi-item dataField="documentNumber" editorType="dxTextBox" [editorOptions]="{ readOnly: true }">
                    <dxo-label location="left" alignment="left" [text]="'CUSTOMER_ORDERS.DOCUMENT_NUMBER' | translate"></dxo-label>
                </dxi-item>
                <dxi-item dataField="pointOfSale" editorType="dxSelectBox" [editorOptions]="{ dataSource: pointsOfSale, valueExpr: 'id', displayExpr: 'name', readOnly: true }">
                    <dxo-label location="left" alignment="left" [text]="'POINTS_OF_SALE.POINT_OF_SALE' | translate"></dxo-label>
                </dxi-item>
            </dxi-item>
            <dxi-item [colCount]="10" itemType="group">
                <dxi-item *ngIf="formData?.buyer" dataField="buyer.name" [editorOptions]="{ readOnly: true }" [colSpan]="5">
                    <dxo-label location="left" alignment="left" [text]="'SHARED.BUYER' | translate"></dxo-label>
                </dxi-item>
                <dxi-item *ngIf="formData?.buyer == null" [colSpan]="5" dataField="shippingFullName" editorType="dxTextBox" [editorOptions]="{ readOnly: true }">
                    <dxo-label location="left" alignment="left" [text]="'SHARED.BUYER' | translate"></dxo-label>
                </dxi-item>
                <dxi-item [colSpan]="5" dataField="shippingEmail" editorType="dxTextBox" [editorOptions]="{ readOnly: true }">
                    <dxo-label location="left" alignment="left" [text]="'SHARED.EMAIL' | translate"></dxo-label>
                </dxi-item>
            </dxi-item>
            <dxi-item itemType="group">
                <dxo-col-count-by-screen [lg]="2" [md]="2" [xs]="1" [sm]="2"></dxo-col-count-by-screen>
                <dxi-item dataField="dateCreated" editorType="dxDateBox" [editorOptions]="{ displayFormat: 'dd.MM.yyyy', dateSerializationFormat:'yyyy-MM-ddTHH:mm:ss', calendarOptions: { firstDayOfWeek: 1 }, readOnly: true }">
                    <dxo-label location="left" alignment="left" [text]="'SHARED.DATE_CREATED' | translate"></dxo-label>
                </dxi-item>
                <dxi-item dataField="date" editorType="dxDateBox" [editorOptions]="{ displayFormat: 'dd.MM.yyyy', dateSerializationFormat:'yyyy-MM-ddTHH:mm:ss', calendarOptions: { firstDayOfWeek: 1 }, readOnly: true }">
                    <dxo-label location="left" alignment="left" [text]="'SHARED.DOCUMENT_DATE' | translate"></dxo-label>
                </dxi-item>
            </dxi-item>
            <dxi-item itemType="group">
                <dxo-col-count-by-screen [lg]="2" [md]="2" [xs]="1" [sm]="2"></dxo-col-count-by-screen>
                <dxi-item dataField="paymentMethod" editorType="dxSelectBox" [editorOptions]="{ dataSource: paymentMethods, displayExpr: 'code', onValueChanged: onPaymentMethodChanged, showClearButton: true, searchEnabled: true }">
                    <dxo-label location="left" alignment="left" [text]="'PAYMENT_METHODS.PAYMENT_METHOD' | translate"></dxo-label>
                    <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="meansOfDelivery" editorType="dxSelectBox" [editorOptions]="{ dataSource: meansOfDelivery, valueExpr: 'id', displayExpr: 'description', showClearButton: true, searchEnabled: true }">
                    <dxo-label location="left" alignment="left" [text]="'MEANS_OF_DELIVERY.MEAN_OF_DELIVERY' | translate"></dxo-label>
                    <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
                </dxi-item> 
            </dxi-item>

            <dxi-item itemType="group">
                <dxo-col-count-by-screen [lg]="2" [md]="2" [xs]="1" [sm]="2"></dxo-col-count-by-screen>
                <dxi-item editorType="dxDateBox" [editorOptions]="{  value: shippmentDate, displayFormat: 'dd.MM.yyyy', width: '100%', onValueChanged: onDateChanged, onInitialized: onInitialized, readOnly: true }">
                    <dxo-label location="left" alignment="left" [text]="'CUSTOMER_ORDERS.EXPECTED_SHIPMENT_DATE' | translate"></dxo-label>
                    <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
                </dxi-item>
                <dxi-item  editorType="dxSelectBox" [editorOptions]="{ dataSource: shippmentTimePeriods, value: shippmentTimePeriod, valueExpr: 'id', displayExpr: 'label', showClearButton: true, searchEnabled: true, onValueChanged: onTimePeriodChanged, readOnly: true }">
                    <dxo-label location="left" alignment="left" [text]="'CUSTOMER_ORDERS.EXPECTED_SHIPMENT_TIME_PERIOD' | translate"></dxo-label>
                    <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
                </dxi-item>

            </dxi-item>
        </dx-form>
    </div>
    <div class="col-xl-6 form-vertical">
        <div class="row fs-12">
            <div class="col-md-6">
                <div class="mt-3 mx-2 mx-md-3">
                    <span class="dx-field-item-label-text"> {{ 'SHARED.ADDRESS' | translate }} :</span>
                    <span class="pull-right text-bolder">{{ formData?.shippingAddress }}</span>
                </div>
                <div class="mt-3 mx-2 mx-md-3">
                    <span class="dx-field-item-label-text"> {{ 'SHARED.MUNICIPALITY' | translate }} :</span>
                    <span class="pull-right text-bolder">{{ selectedShippingMunicipality?.name }}</span>
                </div>
                <div class="mt-3 mx-2 mx-md-3">
                    <span class="dx-field-item-label-text"> {{ 'SHARED.PHONE_NUMBER' | translate }} :</span>
                    <span class="pull-right text-bolder">{{ formData?.shippingPhoneNumber }}</span>
                </div>
                <div class="mt-3 mx-2 mx-md-3">
                    <span class="dx-field-item-label-text"> {{ 'SHARED.LAST_CHANGE' | translate }}:</span>
                    <span class="pull-right text-bolder">{{ utilityService.formatDate(formData?.dateModified) }}</span>
                </div>
                <div class="mt-3 mx-2 mx-md-3">
                    <span class="dx-field-item-label-text"> {{ 'SHARED.DATE_CREATED' | translate }}:</span>
                    <span class="pull-right text-bolder">{{ utilityService.formatDate(formData?.dateCreated) }}</span>
                </div>
                <div *ngIf="formData?.usedPromotionalCode" class="mt-3 mx-2 mx-md-3">
                    <span class="dx-field-item-label-text"> {{ 'ORDER.USED_PROMOTIONAL_CODE' | translate }}:</span>
                    <span class="pull-right text-bolder">{{ formData?.usedPromotionalCode }}</span>
                </div>
            </div>
            <div class="col-md-6">                
                <div class="mt-3 mx-2 mx-md-3">
                    <span class="dx-field-item-label-text">{{ 'CUSTOMER_ORDERS.REGULAR_VALUE' | translate }} :</span>
                    <span class="pull-right text-bolder">{{ utilityService.thousandSeparator(formData?.regularValue) }} KM</span>
                </div>
                <div class="mt-3 mx-2 mx-md-3">
                    <span class="dx-field-item-label-text">{{ 'CUSTOMER_ORDERS.DISCOUNT_VALUE' | translate }} :</span>
                    <span class="pull-right text-bolder">{{ utilityService.thousandSeparator(formData?.regularValue - formData?.saleValue) }} KM</span>
                </div>
                <div class="mt-3 mx-2 mx-md-3">
                    <span class="dx-field-item-label-text">{{ 'CUSTOMER_ORDERS.SALE_VALUE' | translate }} :</span>
                    <span class="pull-right text-bolder">{{ utilityService.thousandSeparator(formData?.saleValue) }} KM</span>
                </div>
                <div class="mt-3 mx-2 mx-md-3">
                    <span class="dx-field-item-label-text">{{ 'CUSTOMER_ORDERS.REBATE_VALUE_PROMO' | translate }} :</span>
                    <span class="pull-right text-bolder">{{ utilityService.thousandSeparator(formData?.rebateValue) }} KM</span>
                </div>
                <div class="mt-3 mx-2 mx-md-3">
                    <span class="dx-field-item-label-text">{{ 'CUSTOMER_ORDERS.INVOICE_VALUE' | translate }} :</span>
                    <span class="pull-right text-bolder">{{ utilityService.thousandSeparator(formData?.invoiceValue) }} KM</span>
                </div>
                <div class="mt-3 mx-2 mx-md-3">
                    <span class="dx-field-item-label-text">{{ 'CUSTOMER_ORDERS.TOTAL_VALUE' | translate }} :</span>
                    <span class="pull-right text-bolder">{{ utilityService.thousandSeparator(formData?.totalValue) }} KM</span>
                </div>
            </div>

            <div class="col-md-6">
                <div class="mt-3 mx-2 mx-md-3" *ngFor="let cost of formData?.costs">
                    <span class="dx-field-item-label-text"> {{ cost.costPolicy.description }} :</span>
                    <span class="pull-right text-bolder">{{ cost.costPolicy.value }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row mt-4">
    <div class="col-12">
        <dx-tab-panel [dataSource]="tabs" class="mb-3" [selectedIndex]="0" [animationEnabled]="true" [swipeEnabled]="true">
            <div *dxTemplate="let tab of 'title'">
                <span>{{ 'CUSTOMER_ORDERS.' + tab | translate }}</span>
            </div>
            <div *dxTemplate="let tab of 'item'">
                <div *ngIf="tab == 'PRODUCTS'" class="tab-content">
                    <app-customer-order-products-list #customerOrderProductsList [customerOrderProducts]='formData?.customerOrderProducts' [pointOfSale]="formData?.pointOfSale" (forcePendingChanges)="pendingChanges = true" (updateCosts)="updateCosts($event)"></app-customer-order-products-list>
                </div>
                <div *ngIf="tab == 'COSTS'" class="tab-content">
                    <app-customer-order-costs #customerOrderCostsList [costs]='formData?.costs' [pointOfSale]="formData?.pointOfSale" (forcePendingChanges)="pendingChanges = true" ></app-customer-order-costs>
                </div>
                <div *ngIf="tab == 'NOTES'" class="tab-content">
                    <app-customer-order-notes #customerOrderNotes [internalNote]='formData?.internalNote' [note]='formData?.note' (forcePendingChanges)="pendingChanges = true"></app-customer-order-notes>
                </div>
                <div *ngIf="tab == 'DELIVERY_INFO'" class="tab-content">
                    <dx-form #formDelivery colCount="5" class="bg-secondary-theme p-4" [formData]="formData" (onFieldDataChanged)="fieldDataChanged($event)"> 
                        <dxi-item dataField="shippingFullName" [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 80 }">
                            <dxo-label location="top" alignment="left" [text]="'SHARED.FULL_NAME' | translate"></dxo-label>
                            <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
                        </dxi-item>
                        <dxi-item dataField="shippingAddress" [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 80 }">
                            <dxo-label location="top" alignment="left" [text]="'SHARED.ADDRESS' | translate"></dxo-label>
                            <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule> 
                        </dxi-item>
                        <dxi-item dataField="shippingPhoneNumber" [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 80 }">
                            <dxo-label location="top" alignment="left" [text]="'SHARED.PHONE_NUMBER' | translate"></dxo-label>
                            <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
                        </dxi-item>
                        <dxi-item dataField="shippingZipCode" [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 80 }">
                            <dxo-label location="top" alignment="left" [text]="'SHARED.POSTAL_CODE' | translate"></dxo-label>
                            <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
                        </dxi-item>
                        <dxi-item dataField="shippingMunicipality" editorType="dxSelectBox" [editorOptions]="{ dataSource: municipalities, valueExpr: 'id', displayExpr: 'name', searchEnabled: true, onSelectionChanged: shippingMunicipalityChanged }">
                            <dxo-label location="top" alignment="left" [text]="'SHARED.MUNICIPALITY' | translate"></dxo-label>
                            <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
                        </dxi-item>
                    </dx-form>
                </div>
                <div *ngIf="tab == 'GIFT_PACKAGES'" class="tab-content">
                    <div class="form-vertical">
                        <div class="col-6 col-lg-3 mx-auto">
                            <div (click)="utilityService.openInNewTab('/gift-packages/'+formData.customerOrderGiftPackage?.id)" class="gift-wrap shortAnim clickable active">
                                <img *ngIf="formData.customerOrderGiftPackage?.image" class="img-fluid" src="{{ bucketBaseUrl }}{{ formData.customerOrderGiftPackage?.image }}">
                                <img *ngIf="!formData.customerOrderGiftPackage?.image" class="img-fluid" src="../../../../../assets/POKLON-PAKET1.png">
                                <hr class="my-1">
                                <p class="text-center m-0 gift-name">{{ formData.customerOrderGiftPackage?.name }}</p>
                                <p [matTooltip]="formData.customerOrderGiftPackage?.description | translate" matTooltipPosition="above" matTooltipHideDelay="200" class="text-center m-0 m-0 gift-description">{{ formData.customerOrderGiftPackage?.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </dx-tab-panel>        
    </div>
</div>